import { Injectable } from "@angular/core";
import { Action } from "@ngrx/store";
import { ActionWithPayload } from "@obg/ngrx-utils";
import { AppError } from "@obg/ngx.core";

import { DataLookUpPayload, DataLookUpResponse } from "./data-lookup-level.model";

export const ACTION_PREFIX = "[Data Lookup]";

export const DATA_LOOKUP_LEVEL_ACTION_TYPE = {
	getDataLookupLevel: `${ACTION_PREFIX} Data Lookup Level`,
	getDataLookupLevelSuccess: `${ACTION_PREFIX} Data Lookup Level Success`,
	getDataLookupLevelFail: `${ACTION_PREFIX} Data Lookup Level Fail`,
	resetState: `${ACTION_PREFIX} Reset State`,
};

@Injectable({
	providedIn: "root",
})
export class DataLookUpLevelAction {
	dataLookUpLevel(payload: DataLookUpPayload): ActionWithPayload {
		return {
			type: DATA_LOOKUP_LEVEL_ACTION_TYPE.getDataLookupLevel,
			payload,
		};
	}

	dataLookUpLevelSuccess(payload: DataLookUpResponse): ActionWithPayload {
		return {
			type: DATA_LOOKUP_LEVEL_ACTION_TYPE.getDataLookupLevelSuccess,
			payload,
		};
	}

	dataLookUpLevelFail(error: AppError | Error): ActionWithPayload {
		return {
			type: DATA_LOOKUP_LEVEL_ACTION_TYPE.getDataLookupLevelFail,
			payload: error,
		};
	}

	resetState(): Action {
		return {
			type: DATA_LOOKUP_LEVEL_ACTION_TYPE.resetState,
		};
	}
}
